import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import NcsMeetingComplete from "./ncsMeetingComplete";
import { getNcsMeetingbyId, saveAndCheckoutNCSMeeting, saveAndCheckInNCSMeeting } from "services/redux/brandActivtion/meetings/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    ncsMeetingsData: state.baMeetingReducer.ncsMeetingData,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getNcsMeetingbyId,
            documentUploadUrl,
            documentUploadUrlPublic,
            saveAndCheckoutNCSMeeting,
            saveAndCheckInNCSMeeting
        },
        dispatch
);
export default connect(mapStateToProps, mapDispatchToProps)(NcsMeetingComplete);